// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ICustomPageable } from './ICustomPageable';
import {
    ICustomPageableFromJSON,
    ICustomPageableFromJSONTyped,
    ICustomPageableToJSON,
    ICustomPageableToJSONTyped,
} from './ICustomPageable';
import type { IEncryptedAccountDto } from './IEncryptedAccountDto';
import {
    IEncryptedAccountDtoFromJSON,
    IEncryptedAccountDtoFromJSONTyped,
    IEncryptedAccountDtoToJSON,
    IEncryptedAccountDtoToJSONTyped,
} from './IEncryptedAccountDto';

/**
 * 
 * @export
 * @interface ICustomPageEncryptedAccountDto
 */
export interface ICustomPageEncryptedAccountDto {
    /**
     * 
     * @type {number}
     * @memberof ICustomPageEncryptedAccountDto
     */
    number?: number;
    /**
     * 
     * @type {number}
     * @memberof ICustomPageEncryptedAccountDto
     */
    size?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ICustomPageEncryptedAccountDto
     */
    last?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ICustomPageEncryptedAccountDto
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ICustomPageEncryptedAccountDto
     */
    empty?: boolean;
    /**
     * 
     * @type {Array<IEncryptedAccountDto>}
     * @memberof ICustomPageEncryptedAccountDto
     */
    content?: Array<IEncryptedAccountDto>;
    /**
     * 
     * @type {ICustomPageable}
     * @memberof ICustomPageEncryptedAccountDto
     */
    pageable?: ICustomPageable;
    /**
     * 
     * @type {number}
     * @memberof ICustomPageEncryptedAccountDto
     */
    total_pages?: number;
    /**
     * 
     * @type {number}
     * @memberof ICustomPageEncryptedAccountDto
     */
    number_of_elements?: number;
    /**
     * 
     * @type {number}
     * @memberof ICustomPageEncryptedAccountDto
     */
    total_elements?: number;
}

/**
 * Check if a given object implements the ICustomPageEncryptedAccountDto interface.
 */
export function instanceOfICustomPageEncryptedAccountDto(value: object): value is ICustomPageEncryptedAccountDto {
    return true;
}

export function ICustomPageEncryptedAccountDtoFromJSON(json: any): ICustomPageEncryptedAccountDto {
    return ICustomPageEncryptedAccountDtoFromJSONTyped(json, false);
}

export function ICustomPageEncryptedAccountDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICustomPageEncryptedAccountDto {
    if (json == null) {
        return json;
    }
    return {
        
        'number': json['number'] == null ? undefined : json['number'],
        'size': json['size'] == null ? undefined : json['size'],
        'last': json['last'] == null ? undefined : json['last'],
        'first': json['first'] == null ? undefined : json['first'],
        'empty': json['empty'] == null ? undefined : json['empty'],
        'content': json['content'] == null ? undefined : ((json['content'] as Array<any>).map(IEncryptedAccountDtoFromJSON)),
        'pageable': json['pageable'] == null ? undefined : ICustomPageableFromJSON(json['pageable']),
        'total_pages': json['totalPages'] == null ? undefined : json['totalPages'],
        'number_of_elements': json['numberOfElements'] == null ? undefined : json['numberOfElements'],
        'total_elements': json['totalElements'] == null ? undefined : json['totalElements'],
    };
}

export function ICustomPageEncryptedAccountDtoToJSON(json: any): ICustomPageEncryptedAccountDto {
    return ICustomPageEncryptedAccountDtoToJSONTyped(json, false);
}

export function ICustomPageEncryptedAccountDtoToJSONTyped(value?: ICustomPageEncryptedAccountDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'number': value['number'],
        'size': value['size'],
        'last': value['last'],
        'first': value['first'],
        'empty': value['empty'],
        'content': value['content'] == null ? undefined : ((value['content'] as Array<any>).map(IEncryptedAccountDtoToJSON)),
        'pageable': ICustomPageableToJSON(value['pageable']),
        'totalPages': value['total_pages'],
        'numberOfElements': value['number_of_elements'],
        'totalElements': value['total_elements'],
    };
}

